// extracted by mini-css-extract-plugin
export default {"wrap":"dF-z","fullWidth":"eF-z","hideOnDesktop":"fF-z","content":"gF-z","hasOpenedNav":"hF-z","crumbsList":"iF-z","dropdownsWrap":"jF-z"};